import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { useDispatch } from "react-redux";
import routes from "../routes/routes";
import {LoginCallback, useOktaAuth} from "@okta/okta-react";
import config from "../config";
import {UserClaims} from "@okta/okta-auth-js";
type Props = RouteComponentProps & {};

const AuthCallback: React.FC<Props> = props => {
  const dispatch = useDispatch();
  const {authState, oktaAuth} = useOktaAuth();

  const defaultDomain = config.app.defaultDomain;
  function getCoreUsername(userClaims : UserClaims) {
    let coreUsername = 'Anonymous';
    const usernameMap = config.app.usernameMapping;
    // tslint:disable-next-line:prefer-conditional-expression
    if (usernameMap && usernameMap !== '') {
      // tslint:disable-next-line:no-console
      console.debug(`using mapped attribute from config as username: ${usernameMap}` )
      coreUsername = (userClaims[usernameMap] as string);
    } else {
      // tslint:disable-next-line:no-console
      console.debug(`using 'preferred_username' attribute as username ` )
      coreUsername = (userClaims.preferred_username as string);
    }
    // tslint:disable-next-line:no-console
    console.debug("original username? " + coreUsername)
    // tslint:disable-next-line:no-console
    console.debug("current defaultDomain? " + defaultDomain)
    // @ts-ignore
    if (defaultDomain && defaultDomain !== '') {
      const atDomain = `@${defaultDomain}`;
      // tslint:disable-next-line:no-console
      console.debug("current atDomain? " + atDomain)
      if (coreUsername.endsWith(atDomain)) {
        coreUsername = coreUsername.replace(atDomain, "");
        // tslint:disable-next-line:no-console
        console.debug("replaced username? " + coreUsername)
      }
    }
    return coreUsername;
  }
  function dispatchAuth(accessToken:any, coreUsername:any) {
    dispatch({
      type: "SET_AUTH",
      payload: {
        token: accessToken,
        username: coreUsername
      }
    })
  }
  useEffect(() => {
    if (authState?.isAuthenticated) {
      oktaAuth.getUser().then(userClaims => {
        // tslint:disable-next-line:no-console
        console.debug("dispatching userinfo");
        const accessToken = oktaAuth.getAccessToken();
        const coreUsername = getCoreUsername(userClaims);
        dispatchAuth(accessToken, coreUsername)
        // tslint:disable-next-line:no-console
        console.debug("dispatched userinfo");
      })
    }
  })

  return <LoginCallback/>;
};

export default AuthCallback;
